import { Typography } from "antd"
import styles from "./index.module.less"

const Title = props => {
  const { children, titleFontSize, style, ...rest } = props
  const { Title } = Typography

  return (
    <Title {...rest} style={{ fontSize: titleFontSize, ...style }}>
      {children}
    </Title>
  )
}

export default Title
